module.exports = __webpack_public_path__ + "img/check_red.3217fa52.svg";